import { render, staticRenderFns } from "./MainLedgerCard11ConnectCRUD.vue?vue&type=template&id=12566e7d"
import script from "./MainLedgerCard11ConnectCRUD.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard11ConnectCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports